import { GetTripDetailsResponse, TripPersonType } from '../../services';

export const getPersonTime = (
  trip: GetTripDetailsResponse,
  personType: TripPersonType
): string | undefined =>
  trip.persons?.find(({ type }) => type === personType)?.timeStamp;
